// Import of the module

import { formatNumber } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type Company = {
  id: number;
  key: string;
  name: string;
  is_provider: boolean;
  is_etf_provider: boolean;
  is_fund_provider: boolean;
  is_index_provider: boolean;
  number_of_strategy: number;
  number_of_portfolio: number;
  publication_delay: number;
};

// Definition of the columns

export const companies_columns: ColumnDef<Company>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "key",
    header: "Key",
  },
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "is_provider",
    header: "Provider",
    cell: ({ row }) => (
      <span>{row.getValue("is_provider") ? "Yes" : "No"}</span>
    ),
  },
  {
    accessorKey: "is_etf_provider",
    header: "ETF Provider",
    cell: ({ row }) => (
      <span>{row.getValue("is_etf_provider") ? "Yes" : "No"}</span>
    ),
  },
  {
    accessorKey: "is_fund_provider",
    header: "Fund Provider",
    cell: ({ row }) => (
      <span>{row.getValue("is_fund_provider") ? "Yes" : "No"}</span>
    ),
  },
  {
    accessorKey: "is_index_provider",
    header: "Index Provider",
    cell: ({ row }) => (
      <span>{row.getValue("is_index_provider") ? "Yes" : "No"}</span>
    ),
  },
  {
    accessorKey: "number_of_strategy",
    header: "Number of Strategies",
    cell: ({ row }) => {
      const value = row.getValue("number_of_strategy") as number;
      return <span>{formatNumber(value)}</span>;
    },
  },
  {
    accessorKey: "number_of_portfolio",
    header: "Number of Portfolios",
    cell: ({ row }) => {
      const value = row.getValue("number_of_portfolio") as number;
      return <span>{formatNumber(value)}</span>;
    },
  },
  {
    accessorKey: "publication_delay",
    header: "Publication Delay (Business Days)",
    cell: ({ row }) => {
      const value = row.getValue("publication_delay") as number;
      return <span>{formatNumber(value)}</span>;
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end gap-2">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
